import { createContext, useState } from 'react';

const CalendarioContext = createContext();

export const CalendarioProvider = ({ children }) => {
  const today = new Date();
  const [date, setDate] = useState({
    dateFrom: today.toISOString().split('T')[0],
    dateTo: '',
  });
  const [dia, setDia] = useState({});
  const [rooms, setRooms] = useState([]);
  const [people, setPeople] = useState('');
  const [reservationType, setReservationType] = useState('');

  const data = {
    date,
    setDate,
    dia,
    setDia,
    rooms,
    setRooms,
    people,
    setPeople,
    setReservationType,
    reservationType,
  };

  return (
    <CalendarioContext.Provider value={data}>
      {children}
    </CalendarioContext.Provider>
  );
};

export default CalendarioContext;
